import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Loader.css';

const CustomCircleLoader = (props) => {
    const { size = 48, singleColor = '#090B1E', borderSize = 5 } = props;
    return (
        <div className={s.customCircleLoad} style={{ width: size, height: size, borderColor: singleColor, borderWidth: borderSize }}></div>
    )
}

export default withStyles(s)(CustomCircleLoader);